import { get } from '../utils/ajax.js';

// MX
const inputsToAutoFill = document.querySelectorAll('.js-geo-autofill [name^="user_data[geoLevel"]:not([name="user_data[geoLevel4]"])');
const codePostalElement = document.querySelector('.js-geo-autofill [name="user_data[geoLevel4]"]');
const cpNotFoundText = document.querySelector('.js-geo-autofill')?.dataset.textError;
const cpErrorLengthText = document.querySelector('.js-geo-autofill')?.dataset.textErrorLength;
const loadingText = document.querySelector('.js-geo-autofill')?.dataset.textLoading;
const optionDefaultTextMx = document.querySelector('.js-geo-autofill')?.dataset.textOptionDefault;
const geoLevelMx = 4;
// CO
const departmentElement = document.querySelector('.js-geo-fill [name="user_data[geoLevel1]');
const cityElement = document.querySelector('.js-geo-fill [name="user_data[geoLevel2]');
const optionDefaultTextCo = document.querySelector('.js-geo-fill')?.dataset.textOptionDefault;
const geoLevelCo = 1;

let statusAutocompleteOk = false;

const getGeotreeComponents = (params) => get("/api/v5/geotree/components",params ,true, false).then(response => response);

const removeOptionsSelect = (element) => {
    const options = element.querySelectorAll('option');
    options.forEach(option => option.remove());
}

const addOptionToSelect = (value, text, element, selected) => {
    const opt = document.createElement('option');
    opt.value = value;
    opt.innerHTML = text != null ? text : value;
    if (selected) { opt.defaultSelected = true; }
    element.appendChild(opt);
}

const disabledAutoFillelements = (formEle, text) => {
    formEle.forEach(ele => {
        ele.classList.remove('is-valid', 'is-invalid');
        if (ele.tagName == 'SELECT') {
            removeOptionsSelect(ele);
            addOptionToSelect('', text, ele, true);
        }
        if (ele.tagName == 'INPUT') {
            ele.value = '';
            ele.placeholder = text;
        }
        ele.disabled = true;
    })
}

const messageValidation = (element, text) => {
    element.classList.add('is-invalid');
    if (element.nextElementSibling?.classList.contains('invalid-feedback')) {
        element.nextElementSibling.textContent = text;
    } else {
      const errorFeedback = document.createElement('div');
      errorFeedback.className = 'invalid-feedback';
      errorFeedback.textContent = text;
      element.parentNode?.appendChild(errorFeedback);
    }
}

const fillSelect = (level, elements, selected) => {
    const select = document.querySelector(`[name="user_data[geoLevel${level}]"]`);
    removeOptionsSelect(select);
    addOptionToSelect('',optionDefaultTextMx, select, true);
    elements.forEach((element) => addOptionToSelect(element.name, null, select, selected === element.name ));
    select.disabled = false;
}

const autoFillelements = (current, geotreeComponents) => {
    if(current.level == 1) {
        return;
    }
    const parent = geotreeComponents[`level${current.level - 1}`].find((element) => element.name == current.parent);
    if(!parent) {
        return;
    }

    const control = document.querySelector(`[name="user_data[geoLevel${parent.level}]"]`);

    if (control?.tagName == 'SELECT') {
        fillSelect(parent.level, geotreeComponents[`level${parent.level}`], current.parent);
    } else {
        control.value = parent.name;
    }
    autoFillelements(parent, geotreeComponents);
    control.disabled = false;
}

const checkCorrectMxData = () => {
    if (!statusAutocompleteOk) {
        codePostalElement?.classList.add('is-invalid');
        if (codePostalElement?.value.length !== 5) {
            messageValidation(codePostalElement, cpErrorLengthText);
        }
        disabledAutoFillelements(inputsToAutoFill,'');
    }
}

const autoFillMxAdressForm = async () => {
    let inputValue = codePostalElement?.value || '';
    codePostalElement?.classList.remove('is-valid', 'is-invalid');

    if (inputValue.length === 5) {

        const geotreeComponents = await getGeotreeComponents({
            level: geoLevelMx,
            name: codePostalElement?.value
        });

  
        if (!geotreeComponents.current) {
            statusAutocompleteOk = false;
            messageValidation(codePostalElement, cpNotFoundText);
        } else {
            statusAutocompleteOk = true;
            autoFillelements(geotreeComponents.current, geotreeComponents);
            fillSelect(5, geotreeComponents.children);
            codePostalElement?.classList.add('is-valid');
        }
    }
    else { disabledAutoFillelements(inputsToAutoFill, loadingText); }
}

const autoFillCoAdressForm = async() => {
    const geotreeComponents = await getGeotreeComponents({
        level: geoLevelCo,
        name: departmentElement?.value
    });
    cityElement.disabled = false;
    cityElement.classList.remove('is-valid', 'is-invalid');
    departmentElement.classList.remove('is-valid', 'is-invalid');
    removeOptionsSelect(cityElement);
    addOptionToSelect('',optionDefaultTextCo, cityElement, true);
    geotreeComponents?.children?.forEach(city => {
        addOptionToSelect(city.name, city.name, cityElement, false);
    });
}

// Onload form MX if city empty show as disabled
if (cityElement?.value === '') {
    cityElement.disabled = true;
}

// Onload form CO check code postal
(async function() {
	if (codePostalElement) {

        const geotreeComponents = await getGeotreeComponents({
            level: geoLevelMx,
            name: codePostalElement?.value
        });
        if (!geotreeComponents.current) {
            statusAutocompleteOk = false;
            messageValidation(codePostalElement, cpNotFoundText);
            disabledAutoFillelements(inputsToAutoFill,'');
        }
        if (codePostalElement.value.length !== 5) {
            statusAutocompleteOk = false;
            messageValidation(codePostalElement, cpErrorLengthText);
            disabledAutoFillelements(inputsToAutoFill,'');
        }
    }
})();

// Shipping data form MX
codePostalElement?.addEventListener('keyup', autoFillMxAdressForm, false);
codePostalElement?.addEventListener('blur', checkCorrectMxData, false);

// Shipping data form CO
departmentElement?.addEventListener('change', autoFillCoAdressForm, false);

